/**
 * @generated SignedSource<<414339d004cfc6b3fd9290ea533dec0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type atomsCurrentShareContentAtomBase$data = {
  readonly __typename: "Article";
  readonly " $fragmentSpreads": FragmentRefs<"contentShareWidgetContent">;
  readonly " $fragmentType": "atomsCurrentShareContentAtomBase";
} | {
  readonly __typename: "Video";
  readonly " $fragmentSpreads": FragmentRefs<"contentShareWidgetContent">;
  readonly " $fragmentType": "atomsCurrentShareContentAtomBase";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "atomsCurrentShareContentAtomBase";
};
export type atomsCurrentShareContentAtomBase$key = {
  readonly " $data"?: atomsCurrentShareContentAtomBase$data;
  readonly " $fragmentSpreads": FragmentRefs<"atomsCurrentShareContentAtomBase">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "atomsCurrentShareContentAtomBase"
};

(node as any).hash = "60f432631da6206b92df7757c4ab1619";

export default node;
